// @flow
import React, { useState } from 'react';
import {
  MdClose,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import BannerMessages from '../TemporalBanner';
import CityFooter from '../CityFooter';
import CreateUserForm from '../CreateUserForm';
import styles from './createUserPopover.css';
import PopupContainer from '../PopupContainer';
import PopupCloseButton from '../PopupCloseButton';
import PopupContent from '../PopupContent';
import Card from '../Card';
import Tabs from '../Tabs';
import Tab from '../Tab';

import {
  DRIVER_RESULT_TYPE,
  PARENT_RESULT_TYPE,
  MONITOR_RESULT_TYPE,
  STUDENT_RESULT_TYPE,
} from '../UserSearchResult/types';

const profileTypes = [
  STUDENT_RESULT_TYPE,
  PARENT_RESULT_TYPE,
  MONITOR_RESULT_TYPE,
  DRIVER_RESULT_TYPE,
];

const CreateUserPopupContent = () => {
  const [profileType, setProfileType] = useState(profileTypes[0]);

  return (
    <PopupContainer
      isFullscreen
      verticalAlign="flex-top"
      className={styles.popupContent}
    >
      <div className={styles.bannerContainer}>
        <BannerMessages />
      </div>
      <div className={styles.closeButton}>
        <PopupCloseButton
          size="medium"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </div>
      <PopupContent
        clearPaddings
        isBorderless
        className={styles.content}
      >
        <Card
          isRound
          elevation={3}
          clearMargins
          className={styles.card}
        >
          <Tabs
            onChange={index => setProfileType(profileTypes[index])}
          >
            <Tab title={i18n.t('labels.students', { count: 1 })} />
            <Tab title={i18n.t('labels.parent', { count: 1 })} />
            <Tab title={i18n.t('labels.monitor', { count: 1 })} />
            <Tab title={i18n.t('labels.driver')} />
          </Tabs>
          <CreateUserForm userType={profileType} />
        </Card>
      </PopupContent>
      <CityFooter isFixed />
    </PopupContainer>
  );
};

export default CreateUserPopupContent;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserPopupContent/index.jsx